<template>
	<div class="modal fade" :id="modal.selector" tabindex="-1" role="dialog" aria-hidden="true">
		<div class="modal-dialog modal-lg" role="document">
			<div v-if="attribute" class="modal-content">
				<div class="modal-header">
					<div class="btn-toolbar pull-right" role="toolbar">
						<div class="btn-group" role="group" aria-label="...">
							<button type="button" class="close" data-dismiss="modal" aria-label="Close">
								<span aria-hidden="true">&times;</span>
							</button>
						</div>
					</div>
					<h4  class="modal-title">Formula</h4>
				</div>
				<div v-if="attribute.formula" class="modal-body">
					<div class="row">
						<div v-if="operations" class="col-md-12">
							<select v-if="operations.length" v-model="attribute.formula.product_operation_id" class="form-control">
								<option v-for="operation in operations" :value="operation.id">
									{{ operation.name }}
								</option>
							</select>
						</div>
					</div>
				</div>
				<div v-if="attribute.formula" class="modal-footer">
					<button @click="update()" ref="btnUpdate" type="button" class="btn btn-success">Actualizar</button>
					<button @click="destroy()" ref="btnDestroy" type="button" class="btn btn-danger">Eliminar</button>
					<button type="button" class="btn btn-default" data-dismiss="modal">Cerrar</button>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
	import swal from 'sweetalert2'
	import Ladda from 'ladda'
	import Multiselect from 'vue-multiselect'

	export default {
		props: ['user', 'isAuth', 'operations'],
		components: {
			'multiselect': Multiselect,
		},
		data () {
			return {
				modal: {
					selector: 'modal-attribute-formula',
				},

				attribute: null,
				originalAttribute: null,
			}
		},
		methods: {
			open(attribute) {
				this.originalAttribute = attribute
				this.attribute = JSON.parse(JSON.stringify(attribute))

				var modal = $('#'+this.modal.selector)
				modal.modal('show')
			},
			close () {
				var modal = $('#'+this.modal.selector)
				modal.modal('hide')
			},
			operate() {
				if(this.attribute) {
					var val = null
					if(this.attribute.product_attribute_type_field_id == 1) {
						val = this.attribute.value.decimal_value
					}

					if(this.attribute.product_attribute_type_field_id == 2) {
						val = this.attribute.value.integer_value
					}

					if(val) {
						var result = null
						if(this.attribute.formula.product_operation_id == 1) {
							result = parseFloat(val) + parseFloat(this.attribute.formula.value)
						}
						if(this.attribute.formula.product_operation_id == 2) {
							result = parseFloat(val) * parseFloat(this.attribute.formula.value)
						}
						if(result) {
							this.attribute.formula.total = parseFloat(result).toFixed(3)
						}
					}
				}
			},
			update() {
				this.operate()
				var loading = Ladda.create(this.$refs.btnUpdate)
				loading.start()
				this.$http.put('admin/management/products/attribute/formula/' + this.attribute.formula.id, this.attribute.formula)
				.then(response => {
					var formula = response.body.data
					this.originalAttribute.formula = formula
					this.$emit('attributeFormulaUpdated')
					this.close()
					loading.stop()
				}).catch(function(response) {
					loading.stop()
					console.log(response)
				})
			},
			destroy() {
				var loading = Ladda.create(this.$refs.btnDestroy)
				loading.start()
				this.$http.delete('admin/management/products/attribute/formula/' + this.attribute.formula.id)
				.then(response => {
					this.originalAttribute.formula = null
					this.$emit('attributeFormulaUpdated')
					this.close()
					loading.stop()
				}).catch(function(response) {
					loading.stop()
					console.log(response)
				})
			},
		}
	}
</script>


// WEBPACK FOOTER //
// src/components/management/products/views/AttributeFormula.vue